import { getters } from '/@/modules/core/app/helpers/store';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export class BillingRouteConfig extends CurrentEstateRouteConfig {
  /**
   * @returns {boolean}
   * @protected
   */
  async hasAccessToRoute() {
    const authUser = getters.auth.getUser();

    return authUser.canAdvisorAccessBilling || super.hasAccessToRoute();
  }

  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const authUser = getters.auth.getUser();

    return (
      (authUser.permission.canAccessBilling && !!authUser.currentEstate?.billing) ||
      authUser.permission.canAccessClearWillBilling
    );
  }
}
